module.exports = __webpack_public_path__ + "static/media/play_blue_faded.10bf8014.svg";